exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".otp-input{width:40px;height:40px;padding:5px;margin:0 10px;font-size:20px;border-radius:4px;border:1px solid rgba(0,0,0,.3);text-align:center}.otp-input.error{border:1px solid red!important}.otp-input::-webkit-inner-spin-button,.otp-input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);

// exports
